<template>
  <div>
    <div id="userCreateModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <!--begin::Form-->
        <form class="kt-form" @submit="formSubmit">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="kt-portlet__body">
                <div class="kt-section kt-section--first">
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">ชื่อผู้ใช้งาน (UserName):</label>
                        <input
                          id="userName"
                          name="userName"
                          v-model="userName"
                          type="text"
                          maxlength="256"
                          class="form-control"
                          placeholder="ชื่อผู้ใช้งาน (UserName)"
                        />
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">อีเมล:</label>
                        <input id="email" name="email" v-model="email" type="email" maxlength="256" class="form-control" placeholder="อีเมล" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>บทบาท:</label>
                        <!-- <select
                          id="roleName"
                          name="roleName"
                          class="form-control m-select2"
                          style="width: 100%;"
                        ></select> -->
                        <!-- <select2
                          id="roleName"
                          name="roleName"
                          class="form-control m-select2"
                          style="width: 100%;"
                          :select2-options="roleNameOptions"
                          v-model="roleName"
                          ref="roleNameSelect2"
                          :multiple="this.$root.canShow('')"
                        ></select2> -->
                        <treeselect v-model="roleName" :multiple="true" :options="roleNameOptions" :clear-on-select="true" placeholder="กรุณาเลือก" />
                      </div>
                    </div>

                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>โปรไฟล์บริษัท:</label>
                        <!-- <select2 v-if="this.$root.canShow('')"
                          id="usercCompanyProfiles"
                          name="usercCompanyProfiles"
                          class="form-control m-select2"
                          style="width: 100%;"
                          :select2-options="usercCompanyProfilesOptions"
                          v-model="usercCompanyProfiles"
                          ref="usercCompanyProfilesSelect2"
                          :multiple="true"
                        ></select2>
                        <select2 v-else
                          id="usercCompanyProfile"
                          name="usercCompanyProfile"
                          class="form-control m-select2"
                          style="width: 100%;"
                          :select2-options="usercCompanyProfileOptions"
                          v-model="usercCompanyProfile"
                          ref="usercCompanyProfileSelect2"
                          :multiple="false"
                        ></select2> -->
                        <!-- <select2
                          id="usercCompanyProfiles"
                          name="usercCompanyProfiles"
                          class="form-control m-select2"
                          style="width: 100%;"
                          :select2-options="usercCompanyProfilesOptions"
                          v-model="usercCompanyProfiles"
                          ref="usercCompanyProfilesSelect2"
                          :multiple="this.$root.canShow('')"
                        ></select2> -->
                        <treeselect 
                        v-model="usercCompanyProfiles" 
                        :multiple="true" 
                        :options="usercCompanyProfilesOptions" 
                        :clear-on-select="true"
                        placeholder="กรุณาเลือก" />
                        <br />ไม่พบข้อมูลโปรไฟล์บริษัท? คลิกเพื่อสร้าง
                        <a href="javascript:void(0)" @click="showAgentProfileCreateForm">โปรไฟล์ตัวแทนฯ</a>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">รหัสผ่าน:</label>
                        <input
                          id="password"
                          name="password"
                          v-model="password"
                          type="password"
                          maxlength="20"
                          class="form-control"
                          placeholder="รหัสผ่าน"
                        />
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-warning">ยืนยันรหัสผ่าน:</label>
                        <input
                          id="confirmPassword"
                          name="confirmPassword"
                          v-model="confirmPassword"
                          type="password"
                          maxlength="20"
                          class="form-control"
                          placeholder="ยืนยันรหัสผ่าน"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">ชื่อ:</label>
                        <input
                          id="givenName"
                          name="givenName"
                          v-model="givenName"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="ชื่อ"
                        />
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">ชื่อสกุล:</label>
                        <input
                          id="familyName"
                          name="familyName"
                          v-model="familyName"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="ชื่อสกุล"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>ตำแหน่ง:</label>
                        <input
                          id="position"
                          name="position"
                          v-model="position"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="ตำแหน่ง"
                        />
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">เบอร์ติดต่อ:</label>
                        <input
                          id="phoneNumber"
                          name="phoneNumber"
                          v-model="phoneNumber"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="เบอร์ติดต่อ"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Begin:Picture element -->
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <label
                          >รูปลายเซ็นต์:
                          <span class="text-sm text-danger" style="font-size:small">
                            (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)</span
                          ></label
                        >
                        <button type="button" class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2" @click="uploadFile">
                          <i class="flaticon-upload-1"></i>รูป
                        </button>
                        <div class="row" id="container-img">
                          <div
                            v-if="FileUpload && FileUpload.isLoaded"
                            class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap"
                            :id="FileUpload.pictureId"
                          >
                            <img
                              :src="FileUpload.urlImg"
                              class="img-plant -avatar js-avatar-me img-thumbnail card-img-top"
                              @error="handleImageError(FileUpload)"
                              @load="handleImageLoad(FileUpload)"
                            />
                            <a
                              href="javascript:;"
                              style="position:absolute;top:10px;right:20px;"
                              class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                              @click="removeImage"
                            >
                              <span class="m--font-inverse-danger la la-trash"></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End:Picture element -->
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>สถานะ:</label>
                        <div class="form-check">
                          <label class="form-check-label kt-checkbox">
                            <input type="checkbox" class="form-check-input" name="inActiveStatus" id="inActiveStatus" v-model="inActiveStatus" />
                            เปิดใช้งาน
                            <span></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <user-sml-mapping :selectedCompanyProfiles="selectedCompanyProfiles" :userSmlMappings.sync="userSmlMappings"></user-sml-mapping>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="la la-close"></i> ปิดหน้าต่าง</button>
              <button type="submit" class="btn btn-primary"><i class="la la-save"></i> บันทึกข้อมูล</button>
            </div>
          </div>
        </form>
        <!--end::Form-->
      </div>
    </div>
    <agent-profile-create-form ref="agentProfileCreateForm"></agent-profile-create-form>
  </div>
</template>

<script>
import agentProfileCreateForm from "./AgentProfileCreateForm";
import axios from "axios";
import select2 from "../../../Shared/Select2";
import plupload from "plupload";
import Treeselect from "@riophae/vue-treeselect";
import userSmlMapping from "./UserSmlMapping.vue";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    agentProfileCreateForm,
    select2,
    Treeselect,
    userSmlMapping,
  },
  data: function() {
    var self = this;
    return {
      userName: null,
      password: null,
      confirmPassword: null,
      email: null,
      givenName: null,
      familyName: null,
      position: null,
      phoneNumber: null,
      roleName: null,
      companyProfileId: null,
      inActiveStatus: true,
      FileUpload: null,
      usercCompanyProfile: null,
      usercCompanyProfiles: [],
      usercCompanyProfileOptions: {
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      usercCompanyProfilesOptions: {
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      usercCompanyProfilesOptions: [],
      roleNameOptions: [],
      userSmlMappings: [],
      selectedCompanyProfiles: [],
    };
  },
  methods: {
    handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad(image) {
      image.isLoaded = true;
    },
    removeImage(pictureId) {
      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then((result) => {
        if (result.value) {
          this.FileUpload = null;
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.multiple = false;
      input.click();

      input.addEventListener("change", (event) => {
        const file = event.target.files[0];
        if (
          file &&
          ["image/jpeg", "image/jpg", "image/png"].includes(file.type) &&
          file.size <= 10 * 1024 * 1024
        ) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.FileUpload = {
              pictureId: Date.now().toString(),
              fileName: file.name,
              urlImg: e.target.result,
              fileDataContext: file,
              isNew: true,
              isLoaded: true,
            };
          };
          reader.readAsDataURL(file);
        } else {
          alert(
            "กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)"
          );
        }
      });
    },
    showAgentProfileCreateForm: function() {
      $(this.$refs.agentProfileCreateForm.$el).modal("show");
    },
    async formSubmit(e) {
      e.preventDefault();

      if (
        !$("#userCreateModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      if (!Array.isArray(this.usercCompanyProfiles) && this.companyProfile != null) {
        var tempCompanyProfile = this.usercCompanyProfiles;
        this.usercCompanyProfiles = [];
        this.usercCompanyProfiles.push(tempCompanyProfile);
      }

      let uploadedFile = null;

      if ( this.FileUpload && this.FileUpload.isNew && this.FileUpload.fileDataContext ) {
        try {
          const file = this.FileUpload;
          const formData = new FormData();
          formData.append("File", file.fileDataContext);
          formData.append("IsMaster", true);
          formData.append("FolderName", "MasterUser");

          const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          uploadedFile = {
            contentType: "-",
            downloadUrl: uploadResponse.data.fileUrl,
            fileInfoId: uploadResponse.data.fileInfoId,
            fileName: uploadResponse.data.fileInfoId,
            gridFsId: uploadResponse.data.gridFsId,
            sysName: "-",
          };
        } catch (error) {
          console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
        }
      }

      let router = this.$router;
      axios
        .post("/Api/Users/Create", {
          userName: this.userName,
          password: this.password,
          confirmPassword: this.confirmPassword,
          email: this.email,
          givenName: this.givenName,
          familyName: this.familyName,
          position: this.position,
          phoneNumber: this.phoneNumber,
          roles: this.roleName,
          companyProfileId: this.usercCompanyProfiles,
          inActiveStatus: !this.inActiveStatus,
          signImg: uploadedFile,
          userSmlMappings: this.userSmlMappings,
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              $("#userCreateModal").modal("hide");
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    LoadroleNameOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Roles/Options", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.roleNameOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadusercCompanyProfilesOptions: function(e) {
      var self = this;
      axios
        .get("/Api/CompanyProfile/Options", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.usercCompanyProfilesOptions.push({
                id: element.id,
                label: element.text,
                data: element.data,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    handleBackButton(event) {
      const modalBackdrops = document.querySelectorAll('.modal-backdrop');
      modalBackdrops.forEach(modalBackdrop => {
        modalBackdrop.remove();
      });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    self.LoadroleNameOptions();
    self.LoadusercCompanyProfilesOptions();
    window.addEventListener('popstate', this.handleBackButton);

    // set validation rules
    $("#userCreateModal form").validate({
      rules: {
        userName: "required",
        email: {
          required: true,
          email: true,
        },
        password: {
          required: true,
          minlength: 6,
        },
        confirmPassword: {
          equalTo: "#password",
        },
        givenName: "required",
        familyName: "required",
        phoneNumber: "required",
      },
      messages: {
        userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
        email: {
          required: "กรุณากรอกอีเมล",
          email: "กรุณากรอกอีเมลให้ถูกต้อง",
        },
        password: {
          required: "กรุณากรอกรหัสผ่าน",
          minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร",
        },
        confirmPassword: {
          equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง",
        },
        givenName: "กรุณากรอกชื่อ",
        familyName: "กรุณากรอกชื่อสกุล",
        phoneNumber: "กรุณากรอกเบอร์โทรศัพท์",
      },
    });

    // $("#userCreateModal #roleName")
    //   .select2({
    //     placeholder: "เลือกบทบาท",
    //     allowClear: true,
    //     ajax: {
    //       url: "/Api/Roles/Options",
    //       data: function(params) {
    //         var query = {
    //           search: params.term,
    //           page: params.page || 1
    //         };
    //         return query;
    //       },
    //       processResults: function(data, params) {
    //         return {
    //           results: data.results,
    //           pagination: {
    //             more: data.more
    //           }
    //         };
    //       },
    //       transport: function(params, success, failure) {
    //         params.beforeSend = function(request) {
    //           request.setRequestHeader(
    //             "Authorization",
    //             "Bearer " + self.$root.user.access_token
    //           );
    //         };
    //         var $request = $.ajax(params);
    //         $request.then(success);
    //         $request.fail(failure);
    //         return $request;
    //       }
    //     }
    //   })
    //   .change(function() {
    //     self.roleName = $(this).val();
    //   });

    // $("#userCreateModal #companyProfile")
    //   .select2({
    //     placeholder: "เลือกโปรไฟล์บริษัท",
    //     allowClear: true,
    //     ajax: {
    //       url: "/Api/CompanyProfile/Options",
    //       data: function(params) {
    //         var query = {
    //           search: params.term,
    //           page: params.page || 1
    //         };
    //         return query;
    //       },
    //       processResults: function(data, params) {
    //         return {
    //           results: data.results,
    //           pagination: {
    //             more: data.more
    //           }
    //         };
    //       },
    //       transport: function(params, success, failure) {
    //         params.beforeSend = function(request) {
    //           request.setRequestHeader(
    //             "Authorization",
    //             "Bearer " + self.$root.user.access_token
    //           );
    //         };
    //         var $request = $.ajax(params);
    //         $request.then(success);
    //         $request.fail(failure);
    //         return $request;
    //       }
    //     }
    //   })
    //   .change(function() {
    //     self.companyProfileId = $(this).val();
    //   });

    $("#userCreateModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
  watch: {
    usercCompanyProfiles() {
      this.selectedCompanyProfiles = this.usercCompanyProfilesOptions.filter((e, i) => this.usercCompanyProfiles.findIndex((a) => a === e.id) >= 0);
    },
  },
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-user {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-user {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-user {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/User/UserCreate.vue